<div class="component-content w-100 h-100" fxLayout="column" fxLayoutAlign="center center">
  <h1>Status - 404</h1>
  <h4>Page not Found.</h4>
</div>
